import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromIntegrations from '../reducers/integrations.reducer';

export const selectIntegrationsState = createFeatureSelector<fromIntegrations.State>(
  fromIntegrations.integrationsFeatureKey
);

export const selectIntegrationsQuickBooksState = createSelector(
  selectIntegrationsState,
  (state: fromIntegrations.State) => state.hasQuickBooks
);